import React from "react";
import Icon from "./Icon";

const DistributionSelect = ({ type, label, distributionType, onClick }) => {
  return (
    <div onClick={onClick} style={{ cursor: "pointer" }}>
      <Icon
        icon={distributionType === type ? "selectCheck" : "selectUnCheck"}
      />
      <text
        style={{
          fontFamily: "Roboto-Regular",
          fontSize: "14px",
          color: "#060808",
          marginLeft: "10px",
        }}
      >
        {label}
      </text>
    </div>
  );
};

export default DistributionSelect;
